import React, { useRef, useEffect } from 'react';
import OurStaff from '../Components/MeetUs/OurStaff';
import MissionAndPromise from '../Components/MeetUs/MissionPromise';
import { useNavigate, useLocation } from 'react-router-dom';
import { useNavigateAndScroll } from '../Hooks/useNavigateAndScroll';

function MeetUs({ data }) {
  const barRef = useRef(null);
  const navigateAndScroll = useNavigateAndScroll();
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigateAndScroll = (pathname, sectionId) => {
    if (location.pathname !== pathname) {
      navigate(pathname);
    }

    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100); // Adjust the timeout as needed to ensure the page has navigated
  };

  useEffect(() => {
    const handleScroll = () => {
      if (barRef.current) {
        const barTop = barRef.current.getBoundingClientRect().top;
        if (barTop <= 0) {
          barRef.current.classList.add('sticky', 'top-0', 'shadow-md');
        } else {
          barRef.current.classList.remove('sticky', 'top-0', 'shadow-md');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Function to scroll to the specified section
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section && barRef.current) {
      const stickyBarHeight = barRef.current.offsetHeight;
      const sectionPosition = section.getBoundingClientRect().top + window.scrollY; // <= Use scrollY here
      const offset = 7;
      const scrollPosition = sectionPosition - stickyBarHeight - offset;
  
      window.scrollTo({
        top: scrollPosition,
        behavior: 'smooth',
      });
    }
  };
  

  return (
    <div>
      <div className="flex justify-center smartphone:hidden items-center relative">
        <div className="relative w-auto z-1 mt-[-120px]">
          <img
            className="w-full h-auto rounded-lg shadow-lg mt-2"
            src="https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/meet+us.webp"
            alt="Mother and child meeting a doctor"
          />
        </div>
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 smartphone:hidden">
            <button className="text-white font-bold bg-custom-regularOrange px-2 py-1 rounded-md hover:bg-custom-darkOrange"
            onClick={() => navigateAndScroll('/patient-center/new-patient')}>
              New to our practice - LET US HELP YOU
            </button>
          </div>
      </div>

      {/* Sticky Bar Below the Image */}
      <div ref={barRef} className="sticky top-0 flex justify-around bg-custom-blue text-white z-50 mb-8">
        <button
          className="p-1 text-sm cursor-pointer grow-text"
          onClick={() => scrollToSection('mission')}
        >
          Mission Statement
        </button>
        <button
          className="p-1 text-sm cursor-pointer grow-text"
          onClick={() => scrollToSection('providers')}
        >
          Our Providers
        </button>
        <button
          className="p-1 text-sm cursor-pointer grow-text"
          onClick={() => scrollToSection('staff')}
        >
          Office Staff
        </button>
        <button
          className="p-1 text-sm cursor-pointer grow-text"
          onClick={() => scrollToSection('history')}
        >
          History
        </button>
      </div>

      <section className="" id="mission">
        <MissionAndPromise />
      </section>
      <OurStaff data={data} />
      <div className="max-w-4xl mx-auto p-4">
        <section id="history">
          <h1 className="text-4xl text-black font-bold mb-4">History</h1>
          <hr className="mb-8 border-gray-400" />
          <p className="text-lg text-gray-600">Coming soon!</p>
        </section>
      </div>
    </div>
  );
}

export default MeetUs;
